import { fromJS } from 'immutable';
import { memberPortionPaymentTypeNamesMap } from '../../enums/paymentTypes';

export default fromJS({
    memberPaymentTypes: [...Object.entries(memberPortionPaymentTypeNamesMap)].map(([id, name]) => ({ id: Number(id), name }))
});